import {
    CollectionApi,
    CoreFetch,
    ListProviderCollectionPaymentsRequest,
    ProviderCollectionPayment,
} from '@enter/core';
import { IItemListing } from './root.store';
import { fetch, parseResponse } from './util';

export class PaymentService {
    public async fetchPaymentListing(
        lpgr: ListProviderCollectionPaymentsRequest,
    ): Promise<IItemListing<ProviderCollectionPayment> | undefined> {
        const res = await fetch(lpgr, req =>
            CoreFetch<CollectionApi>(CollectionApi).listProviderCollectionPaymentsRaw(req),
        );
        if (res) {
            return {
                items: await parseResponse(res),
                limit: Number(await res.raw.headers.get('pagination-limit')),
                offset: Number(await res.raw.headers.get('pagination-offset')),
                total: Number(await res.raw.headers.get('pagination-total')),
            };
        }
    }
    public async fetchPayment(id: string): Promise<ProviderCollectionPayment | undefined> {
        return fetch({ id }, req => CoreFetch<CollectionApi>(CollectionApi).getProviderCollectionPayment(req));
    }
}
